import type { ComponentType } from 'react';

import {
	SocialInstagramIcon,
	SocialLinkedInIcon,
	SocialTikTokIcon,
	SocialXIcon,
} from './social-icons';

export interface FooterSocialLink {
	label: string;
	href: string;
	icon: ComponentType<{ className?: string }>;
}

/**
 * The social row. Lives in `@naumu/ui` rather than the marketing app because
 * two different deployables render it: the marketing footer
 * (`apps/marketing`) and the sign-in shell (`apps/web`).
 */
export const FOOTER_SOCIAL: readonly FooterSocialLink[] = [
	{ label: 'X', href: 'https://x.com/naumu_ai', icon: SocialXIcon },
	{ label: 'LinkedIn', href: 'https://www.linkedin.com/company/naumu', icon: SocialLinkedInIcon },
	{ label: 'Instagram', href: 'https://www.instagram.com/naumu.ai/', icon: SocialInstagramIcon },
	{ label: 'TikTok', href: 'https://www.tiktok.com/@naumu.ai', icon: SocialTikTokIcon },
] as const;
